import { render, staticRenderFns } from "./InventoryStockOpnameDetail.vue?vue&type=template&id=3565ab3a"
import script from "./InventoryStockOpnameDetail.vue?vue&type=script&lang=js"
export * from "./InventoryStockOpnameDetail.vue?vue&type=script&lang=js"
import style0 from "./InventoryStockOpnameDetail.vue?vue&type=style&index=0&id=3565ab3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports